import isHtmlElementNode from '@atlas/tool/box/dom/isHtmlElementNode';

export default function isMultiLineTextHtmlElement(node: Node): node is TMultiLineTextHtmlElement {
    return isHtmlElementNode(node, 'PRE') || isHtmlElementNode(node, 'BLOCKQUOTE');
}

// #region Types

export type TMultiLineTextHtmlElement =
    | (HTMLPreElement & { tagName: 'PRE' })
    | (HTMLQuoteElement & { tagName: 'BLOCKQUOTE' });

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect, expectTypeOf } = import.meta.vitest;
    describe('isMultiLineHtmlElement', () => {
        test('results with false for non-html elements', () => {
            expect(isMultiLineTextHtmlElement(document)).toBe(false);
            expect(isMultiLineTextHtmlElement(document.createTextNode('text'))).toBe(false);
        });

        test('results with true only for multi-line text html elements', () => {
            expect(isMultiLineTextHtmlElement(document.createElement('pre'))).toBe(true);
            expect(isMultiLineTextHtmlElement(document.createElement('blockquote'))).toBe(true);
            expect(isMultiLineTextHtmlElement(document.createElement('iframe'))).toBe(false);
        });

        test('justifies type of the given node to match the result of comparison', () => {
            const node: Node = document;

            isMultiLineTextHtmlElement(node)
                ? expectTypeOf(node).toMatchTypeOf<HTMLPreElement | HTMLQuoteElement>()
                : expectTypeOf(node).not.toMatchTypeOf<HTMLPreElement | HTMLQuoteElement>();
        });
    });
}

// #endregion
